import React, { FC, useCallback, useEffect, useState } from 'react';
import { WysiwygTextProps, WysiwygTextPropsModel } from './WysiwygText.types';
import { StyledWysiwygText } from './WysiwygText.styles';

import DOMPurify from 'isomorphic-dompurify';
import clsx from 'clsx';
import { debounce, useDCADynamicModelAlloy } from '../../modules/helpers';
import { EditableComponent } from '@adobe/aem-react-editable-components';

export const WysiwygText: FC<WysiwygTextProps> = (props: WysiwygTextProps) => {
  /**
   * Fetching the target response
   */
  const mboxParam = props?.model?.mboxParameter;

  /***
   * Makes the call to target if mboxParam is authored
   */
  const targetResponse = useDCADynamicModelAlloy(mboxParam);
  const targetData = targetResponse?.targetData;

  /**
   * Replacing the AEM model data with target data if target Response is present
   */

  const componentValues: WysiwygTextPropsModel = targetData ? targetData : props.model;
  const [viewPort, setViewPort] = useState('Desktop');

  useEffect(() => {
    /**
     * debouncing handle resize event as it trigger's on every subsequent re size.
     * function will be executed only after the user has stopped resizing for a 300ms delay
     */
    const debouncedResize = debounce(handleResize, 300);

    window.addEventListener('resize', debouncedResize);
    return () => {
      window.removeEventListener('resize', debouncedResize);
    };
  }, []);

  const handleResize = useCallback(() => {
    const xs = window.matchMedia('(max-width: 767px)');
    const md = window.matchMedia('(min-width: 768px) and (max-width: 1199px)');
    const lg = window.matchMedia('(min-width: 1200px)');
    if (xs?.matches) {
      setViewPort('Mobile');
    } else if (md?.matches) {
      setViewPort('Tablet');
    } else if (lg?.matches) {
      setViewPort('Desktop');
    }
  }, []);

  return (
    <StyledWysiwygText className={componentValues?.styleclass}>
      <div
        className={clsx(
          'row t-font-m',
          viewPort === 'Mobile' && 'txt-container-mob',
          viewPort !== 'Mobile' && 'txt-container',
          !componentValues?.disableStyling && 'wysiwyg-first-letter'
        )}
      >
        <div
          className={clsx('mob-view-gutter-space offset-1 col-10 col-md-8 col-xl-8 offset-md-2')}
          dangerouslySetInnerHTML={{
            __html: (
              DOMPurify.sanitize(componentValues?.description as string, {
                RETURN_DOM: true,
              }) as HTMLElement
            ).outerHTML,
          }}
        ></div>
      </div>
    </StyledWysiwygText>
  );
};

export const WysiwygTextConfig = {
  emptyLabel: 'WysiwygText',
  isEmpty: () => true,
  resourceType: `mi-aem-luxury-spa/components/content/wysiwyg/v1/wysiwyg`,
};
//TODO:Need to fix the lint issue for editable component
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const WysiwygTextEditable = (props: any) => {
  return (
    <div data-testid="luxury-WysiwygText" data-component-name="m-luxury-WysiwygText">
      <EditableComponent config={WysiwygTextConfig} {...props}>
        <WysiwygText {...props} />
      </EditableComponent>
    </div>
  );
};
